import request from "../../Request";
import {rThen} from "../../requestThen";

export let getGartenInfo = async (kindegartenId) => {

    return request.get(`/api/gartens/get_info/${kindegartenId}`, true).then(r => {
        return rThen(r);
    })
}